export const BANNER_OVERLAY_WIDTH = {
  SIZE_80: 80, // SHOWS, MOVIES
  SIZE_60: 60, // HOME, TV
} as const
export type BANNER_OVERLAY_WIDTH =
  (typeof BANNER_OVERLAY_WIDTH)[keyof typeof BANNER_OVERLAY_WIDTH]
